import { useEffect } from "react";
import SegmentSidebar from "../SegmentSidebar";
import Levels from "./Levels";

const MultiLevel = ({ segment, search, onChange, ...props }) => {
  const onInnerChange = (parents, segment, value) => {
    onChange(segment, value);
  };

  useEffect(() => {}, [search]);

  return (
    <>
      <SegmentSidebar {...props} {...segment}>
        <Levels
          visible={true}
          items={segment.strings}
          selected={search}
          onChange={onInnerChange}
          {...props}
        />
      </SegmentSidebar>
    </>
  );
};

export default MultiLevel;
